import { render, staticRenderFns } from "./ElementABCDPlanTableColumn.vue?vue&type=template&id=397b915c&scoped=true"
import script from "./ElementABCDPlanTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementABCDPlanTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementABCDPlanTableColumn.vue?vue&type=style&index=0&id=397b915c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397b915c",
  null
  
)

export default component.exports